<template>
  <div>
    <!-- Redci umjesto tablice: opis zadatka je recenica, a ne sifra, pa mu
         treba sirina. U tablici je bio stisnut u stupac od 150 px. -->
    <div v-if="saving" class="text-center py-6">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else-if="items.length === 0" class="prazno">
      <v-icon large color="green">mdi-check-circle-outline</v-icon>
      <div class="mt-1">{{ prazanTekst }}</div>
    </div>

    <div v-else>
      <div
        v-for="t in items"
        :key="t.id"
        class="zadatak"
      >
        <!-- Pojas lijevo nosi stanje: crveno kasni, naranca danas, zeleno gotovo. -->
        <div class="pojas" :class="pojasRazred(t)"></div>

        <div class="sredina" @click="otvori(t)">
          <div class="opis" :class="{precrtan: t.taskClosed}">
            {{ t.taskShortDescription ? t.taskShortDescription : lang.TaskNoDescription }}
          </div>
          <div class="meta">
            <span v-if="t.taskTypeDescription" class="znak vrsta">{{ t.taskTypeDescription }}</span>
            <span v-if="zaMene(t)" class="znak ja">{{ lang.TaskForMe }}</span>
            <span v-if="t.CompanyNameDatabase">{{ t.CompanyNameDatabase }}</span>
            <span v-if="t.partnerName"><span class="tocka">&middot;</span>{{ t.partnerName }}</span>
            <span v-if="!t.taskClosed && (t.First || t.Last)">
              <span class="tocka">&middot;</span>{{ lang.TaskAssignedBy }}: {{ t.First }} {{ t.Last }}
            </span>
            <span v-if="t.taskClosed && t.taskClosedDate">
              <span class="tocka">&middot;</span>{{ lang.TaskFinishedBy }}: {{ localDate(t.taskClosedDate) }}
            </span>
            <span v-if="t.taskDetailDescription">
              <span class="tocka">&middot;</span>{{ lang.TaskHasNote }}
            </span>
          </div>
        </div>

        <div class="desna">
          <div v-if="t.taskClosed" class="rok" style="color:#2e7d32">
            <v-icon small color="green">mdi-check</v-icon> {{ lang.TaskDone2 }}
          </div>
          <div v-else class="rok" :class="rokRazred(t)">
            {{ rokTekst(t) }}<br>
            <span class="rok-datum">{{ localDate(t.taskForDate) }}</span>
          </div>

          <v-btn
            v-if="!t.taskClosed && zaMene(t)"
            x-small
            text
            color="green darken-2"
            :loading="zatvaram === t.id"
            @click.stop="obavljeno(t)"
          >
            {{ lang.TaskDone }}
          </v-btn>
        </div>
      </div>
    </div>

    <v-snackbar v-model="poruka.vidi" :color="poruka.boja" :timeout="4000">
      {{ poruka.tekst }}
    </v-snackbar>
  </div>
</template>

<script>
import TaskService from '@/services/TaskService'
import langEn from './taskDescEn'
import langHr from './taskDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'

export default {
  name: 'tasklist',
  props: {
    // Popis slaze roditelj (TaskIndex), jer o odabranom jahacu ovisi koji se
    // upit uopce salje.
    items: {
      type: Array,
      default: () => []
    },
    saving: {
      type: Boolean,
      default: false
    },
    prazanTekst: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lang: {},
      langC: {},
      zatvaram: 0,
      poruka: {vidi: false, tekst: '', boja: 'success'}
    }
  },
  mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
  },
  methods: {
    otvori (task) {
      this.$store.dispatch('seteditItem', 1)
      this.$store.dispatch('setTaskid', task.id)
      this.$router.push({name: 'taskcreate'})
    },
    // Zadatak je moj ako sam ja jedan od pet izvrsitelja. Samo tada se nudi
    // "Obavljeno" - tudji posao se ne zatvara iz popisa.
    zaMene (task) {
      const ja = this.$store.getters.NeedUserID
      if (!ja) { return false }
      for (let i = 1; i <= 5; i++) {
        if (parseInt(task['taskFor' + i + 'UserId'], 10) === parseInt(ja, 10)) { return true }
      }
      return false
    },
    danaDoRoka (task) {
      if (!task.taskForDate) { return null }
      return dayjs(task.taskForDate).startOf('day').diff(dayjs().startOf('day'), 'day')
    },
    pojasRazred (task) {
      if (task.taskClosed) { return 'gotov' }
      const d = this.danaDoRoka(task)
      if (d === null) { return '' }
      if (d < 0) { return 'hitno' }
      if (d === 0) { return 'danas' }
      return ''
    },
    rokRazred (task) {
      const d = this.danaDoRoka(task)
      if (d === null) { return '' }
      if (d < 0) { return 'kasni' }
      if (d === 0) { return 'danas' }
      return ''
    },
    rokTekst (task) {
      const d = this.danaDoRoka(task)
      if (d === null) { return '' }
      if (d === 0) { return this.lang.TaskToday }
      if (d < 0) { return this.lang.TaskLate + ' ' + Math.abs(d) + ' ' + this.lang.TaskDays }
      return this.lang.TaskInDays + ' ' + d + ' ' + this.lang.TaskDays
    },
    async obavljeno (task) {
      try {
        this.zatvaram = task.id
        await TaskService.taskzatvori(task.id, {
          UserId: this.$store.getters.NeedUserID,
          email: this.$store.getters.NeedUseremail
        })
        this.poruka = {vidi: true, tekst: this.lang.TaskDone, boja: 'success'}
        // Roditelj ponovno dohvaca popis i osvjezava brojcic.
        this.$emit('zatvoren', task.id)
      } catch (err) {
        const o = err && err.response && err.response.data
        this.poruka = {vidi: true, tekst: o && o.error ? o.error : 'Greška', boja: 'error'}
      } finally {
        this.zatvaram = 0
      }
    },
    localDate (d) {
      return d ? dayjs(d).format('DD.MM.YYYY') : ''
    }
  }
}
</script>

<style scoped>
.zadatak {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f3f6;
  align-items: flex-start;
}
.zadatak:hover { background: #fafcff; }
.zadatak:last-child { border-bottom: none; }

.pojas {
  width: 4px;
  flex: 0 0 4px;
  align-self: stretch;
  border-radius: 2px;
  background: #cfd8dc;
}
.pojas.hitno { background: #c62828; }
.pojas.danas { background: #ef6c00; }
.pojas.gotov { background: #2e7d32; }

.sredina { flex: 1 1 auto; min-width: 0; cursor: pointer; }
.opis { font-weight: 500; line-height: 1.35; }
.opis.precrtan { text-decoration: line-through; color: #5f6b7a; font-weight: 400; }
.meta { font-size: 12px; color: #5f6b7a; margin-top: 3px; }
.meta .tocka { opacity: .5; margin: 0 5px; }

.znak {
  display: inline-block;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  background: #eceff1;
  color: #455a64;
  margin-right: 5px;
  white-space: nowrap;
}
.znak.vrsta { background: #e8eaf6; color: #3949ab; }
.znak.ja { background: #e8f5e9; color: #2e7d32; }

.desna {
  flex: 0 0 auto;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}
.rok { font-size: 12px; white-space: nowrap; line-height: 1.3; }
.rok.kasni { color: #c62828; font-weight: 700; }
.rok.danas { color: #ef6c00; font-weight: 700; }
.rok-datum { font-weight: 400; }

.prazno { text-align: center; padding: 34px 12px; color: #5f6b7a; }

/* Na uskom ekranu rok i gumb idu ispod opisa, da se opis ne stisne. */
@media (max-width: 600px) {
  .zadatak { flex-wrap: wrap; }
  .desna {
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    padding-left: 14px;
    gap: 10px;
  }
}
</style>
